/* eslint-disable @typescript-eslint/naming-convention */
import './OfferSearchMapList.css';

import React from 'react';
import Icon from '@vtblife/uikit-icons';
import { Size } from '@vtblife/uikit/legacy';

import classname from '@search/classname/src';
import { useOfferSearchMapPageState } from '@search/vtbeco-frontend-core/domain/offer/search/page/useOfferSearchPageState2';
import NewBuildingBaseSnippet from '@search/vtbeco-frontend-core/domain/newbuilding/components/mobile/NewBuildingBaseSnippet';
import { SnippetProviderContext } from '@search/vtbeco-frontend-core/domain/newbuilding/components/desktop/NewBuildingBaseSnippet/snippetContext';
import { useClassifiedOfferDataLayerPush } from '@search/vtbeco-frontend-core/domain/offer/analytics/ClassifiedOfferGtmContext';
import { ClassifiedOfferGtmContext, createOfferGtm2Context } from '@search/vtbeco-frontend-core/domain/offer/analytics/ClassifiedOfferGtmContext';

import { OfferSearchMapItem } from './item/OfferSearchMapItem';

const cn = classname.bind(null, 'OfferSearchMapList');

export function OfferSearchMapList({
    selected,
    handleClose
}: {
    handleClose: () => void;
    selected: {
        forceFavoriteUpdate?(): void;
        geoHash?: string;
        selectedOffers?: readonly string[];
    };
}) {
    const dataLayerPush = useClassifiedOfferDataLayerPush();

    const {
        collection,
        loading,
        offersCount,
        offersCountRealtyFormatted,
        newBuilding
    } = useOfferSearchMapPageState(selected);

    const close = React.useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        e.stopPropagation();
        handleClose();
    }, [ handleClose ]);

    return (<div className={cn()}>
        <div className={cn('header')}>
            <div className={cn('header-text')}>
                {offersCount} {offersCountRealtyFormatted}
            </div>
            <div className={cn('header-actions')}>
                <button
                    data-test='offers-multi-close'
                    onClick={close}
                    className={cn('header-close')}
                >
                    <Icon name='times' size={Size.Small} />
                </button>
            </div>
        </div>
        <div className={cn('offers-container')}>
            {
                newBuilding ? (
                    <div
                        className={cn('nb')}
                        onClick={() => dataLayerPush({ event: 'cl_ToNB_map_over_snippet_block' })}
                    >
                        <SnippetProviderContext>
                            <NewBuildingBaseSnippet newBuilding={newBuilding} />
                        </SnippetProviderContext>
                    </div>
                ) : null
            }
            {loading ? '' : <div>
                {collection.map(model => (
                    <div
                        className={cn('item')}
                        key={model.id}
                    >
                        <ClassifiedOfferGtmContext.Provider
                            value={createOfferGtm2Context({ place: 'map', offer: model })}
                        >
                            <OfferSearchMapItem
                                model={model}
                                forceFavoriteUpdate={selected.forceFavoriteUpdate}
                            />
                        </ClassifiedOfferGtmContext.Provider>
                    </div>
                ))}
            </div>}
        </div>
    </div>);
}
